import { AuthorizationTokenResponse } from "src/lib/itaptec/http_client/src"

export enum AuthorizationRequestFields {
    Mail = 'mail',
    Password = 'password',
    ClientIp = 'ipClient'
}

export interface AuthorizationRequest {
    [AuthorizationRequestFields.Mail]: string
    [AuthorizationRequestFields.Password]: string
    [AuthorizationRequestFields.ClientIp]: string
}

export enum AuthorizationResponseFields {
    UserId = 'idUsuario',
    ProfileIds = 'idsPerfil',
    Lastname = 'apellidoNombre',
    GroupIds = 'idsGrupo',
    PersonRoleId = 'idRolPersona',
    PasswordChangeDaysRemaining = 'cantDiasParaCambiarPass',
    DefaultLanguage = 'idiomaDefault',
    IsBankGroup = 'esGrupoBanco',
    IsInternalGroup = 'esGrupoInterno',
    AccessToken = 'accessToken',
    HasError = 'tieneError',
    ErrorDescription = 'descripcionError',
    IsAdmin = 'bitAdministrador',
    CodCargo = 'tinCodUsuarioCargo',
    Cargo = 'vchDescUsuarioCargo',
    CanCreateNewMessage = 'bitPermiteCargarOperaciones',
    Mail = 'mail'
}

export interface AuthorizationResponse {
    [AuthorizationResponseFields.UserId]: number
    [AuthorizationResponseFields.ProfileIds]: string
    [AuthorizationResponseFields.Lastname]: string
    [AuthorizationResponseFields.GroupIds]: string
    [AuthorizationResponseFields.PersonRoleId]: number | null
    [AuthorizationResponseFields.PasswordChangeDaysRemaining]: number
    [AuthorizationResponseFields.DefaultLanguage]: string
    [AuthorizationResponseFields.IsBankGroup]: boolean
    [AuthorizationResponseFields.IsInternalGroup]: boolean
    [AuthorizationResponseFields.AccessToken]: string
    [AuthorizationResponseFields.HasError]: boolean
    [AuthorizationResponseFields.ErrorDescription]: string
    [AuthorizationResponseFields.IsAdmin]: boolean
    [AuthorizationResponseFields.CodCargo]: number
    [AuthorizationResponseFields.Cargo]: string
    [AuthorizationResponseFields.CanCreateNewMessage]: boolean

    "tokenAutorizacion": AuthorizationTokenResponse, //Por compatibilidad con http_client
    [AuthorizationResponseFields.Mail]: string
}

export enum GoogleAuthFields {
    Token = 'token'
}

export interface GoogleAuthorizationRequest {
    [GoogleAuthFields.Token]: string
}

export enum ChangePasswordRequestFields {
    CurrentPassword = 'passwordActual',
    NewPassword = 'passwordNueva',
}

export interface ChangePasswordRequest {
    [ChangePasswordRequestFields.CurrentPassword]: string,
    [ChangePasswordRequestFields.NewPassword]: string
}